var _defs, _path, _path2, _path3, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313 351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#58c1ec;fill-rule:evenodd;}.cls-2{fill:#78bf56;}.cls-3{font-size:32px;fill:#fff;font-family:MyriadPro-Regular, Myriad Pro;}.cls-4{letter-spacing:-0.06em;}.cls-5{letter-spacing:-0.01em;}.cls-6{letter-spacing:0em;}.cls-7{letter-spacing:0em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.21,110.06c-24.67-3.56-53-21.47-68.16-59.36a8.92,8.92,0,0,0-8.41-5.7H92.36A8.91,8.91,0,0,0,84,50.71C68.76,88.6,40.46,106.5,15.79,110.06A9,9,0,0,0,8,119.23C9.72,215.48,41,316.44,153,336.33c112-19.89,143.28-120.85,145-217.1a9,9,0,0,0-7.77-9.17ZM214.92,247h0a87.85,87.85,0,1,1,25.56-61.95A86.79,86.79,0,0,1,214.92,247Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.42,236.39A12.46,12.46,0,0,0,216.78,226c-.89-4.41-1.74-8.58-2.38-12.22a25.73,25.73,0,0,0-16.54-20L179,186.18C167.7,181.63,163.62,194,155,194.1c-8.49.06-12.6-12.5-24-7.93l-18.84,7.63a25.73,25.73,0,0,0-16.54,20c-.64,3.64-1.49,7.8-2.38,12.22a12.43,12.43,0,0,0,2.36,10.35,76.69,76.69,0,0,0,118.84,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155,175.77c17.43,0,27-23.22,27-38.22a27,27,0,1,0-54.07,0c0,15,9.61,38.22,27,38.22Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(96.51 82.89)"
  }, "PRI", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 41.89,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 57.92,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 77.02,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 95.68,
    y: 0
  }, "Y "))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.c79ef5c498848cd9b939bf0c792130bc.svg";
export { ForwardRef as ReactComponent };